/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IVisitable } from '../../core/models/IVisitable';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IAaiTrait extends IVisitable {
    getTraitType() : AaiTraitType;
}



import { AaiTraitType } from './AaiTraitType';

